import React, { useState } from 'react'

export default function GroupForm({ group, save, isLoading }){
  const [ name, setName ] = useState(group.name || '');
  const [ description, setDescription ] = useState(group.description || '');

  const [ errors, setErrors ] = useState({});
  const validations = [];

  function validate(e) {
    e.preventDefault();

    if (!name) {
      validations.push(['name', 'Nombre es requerido']);
    }

    if(validations.length){
      setErrors(validations.reduce((acc, item) => ({...acc, [item[0]]: item[1]}), {}));
      return;
    }else{
      setErrors([]);
    }

    save({
      ...group,
      name,
      description,
    });
  }

  return (
    <form onSubmit={validate}>
      <div className="form-group">
        <label className="font-weight-bold">Nombre</label>
        <input
          type="text"
          className={`form-control ${errors.name ? 'is-invalid' : ''}`}
          onChange={e => setName(e.target.value)}
          value={name}
          disabled={isLoading}
          autoFocus={true}
        />

        <div className="invalid-feedback">{errors.name}</div>
      </div>

      <div className="form-group">
        <label className="font-weight-bold">Descripción</label>

        <textarea
          className="form-control"
          value={description}
          onChange={e => setDescription(e.target.value)}
        ></textarea>
      </div>

      <div className="form-group">
        <button className={`btn btn-primary ${isLoading ? 'loading' : ''}`} disabled={isLoading}>
          <span>Guardar</span>
          <div className='spinner-border' role='status'></div>
        </button>
      </div>
    </form>
  )
}



